/* tslint:disable */
import {
  Users,
  Task
} from '../index';

declare var Object: any;
export interface CheckInCalendarInterface {
  "sfdcId": string;
  "CreatedById"?: string;
  "CreatedDate"?: Date;
  "CurrencyIsoCode"?: string;
  "LastModifiedById"?: string;
  "Name"?: string;
  "OwnerId"?: string;
  "Check_in_Datetime_Planned__c"?: Date;
  "Check_in_Date_Time__c"?: Date;
  "Check_In_Status__c"?: string;
  "Frequency__c"?: string;
  "Key_Result__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  owner?: Users;
  keyResult?: Task;
}

export class CheckInCalendar implements CheckInCalendarInterface {
  "sfdcId": string;
  "CreatedById": string;
  "CreatedDate": Date;
  "CurrencyIsoCode": string;
  "LastModifiedById": string;
  "Name": string;
  "OwnerId": string;
  "Check_in_Datetime_Planned__c": Date;
  "Check_in_Date_Time__c": Date;
  "Check_In_Status__c": string;
  "Frequency__c": string;
  "Key_Result__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  owner: Users;
  keyResult: Task;
  constructor(data?: CheckInCalendarInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CheckInCalendar`.
   */
  public static getModelName() {
    return "CheckInCalendar";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CheckInCalendar for dynamic purposes.
  **/
  public static factory(data: CheckInCalendarInterface): CheckInCalendar{
    return new CheckInCalendar(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CheckInCalendar',
      plural: 'CheckInCalendars',
      path: 'CheckInCalendars',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "Check_in_Datetime_Planned__c": {
          name: 'Check_in_Datetime_Planned__c',
          type: 'Date'
        },
        "Check_in_Date_Time__c": {
          name: 'Check_in_Date_Time__c',
          type: 'Date'
        },
        "Check_In_Status__c": {
          name: 'Check_In_Status__c',
          type: 'string'
        },
        "Frequency__c": {
          name: 'Frequency__c',
          type: 'string'
        },
        "Key_Result__c": {
          name: 'Key_Result__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        owner: {
          name: 'owner',
          type: 'Users',
          model: 'Users',
          relationType: 'belongsTo',
                  keyFrom: 'OwnerId',
          keyTo: 'sfdcId'
        },
        keyResult: {
          name: 'keyResult',
          type: 'Task',
          model: 'Task',
          relationType: 'belongsTo',
                  keyFrom: 'Key_Result__c',
          keyTo: 'sfdcId'
        },
      }
    }
  }
}
